<template>
    <div>
        <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12 class="pb-3">
                <div class="title primary--text">
                  <h4>{{ $t("enrollment.steps.change_password.component.title") }}</h4>
                </div>
                <div class="pt-2 secondary--text subheading">
                  {{ $t("enrollment.steps.change.password.component.subtitle") }}
                </div>
            </v-flex>
            <v-flex xs12>
                <ChangePassword
                :password.sync="password"
                :confirm_password.sync="confirm_password"
                ref="changePasswordForm">
                </ChangePassword>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            :class="[$vuetify.rtl ? 'ml-2' : '']"
            color="primary background--text"
            dark
            @click.stop="onCancel"
            >{{ $t(`${eventPrefix}.btn.cancel`) }}</v-btn>
            <v-btn
            :class="[$vuetify.rtl ? 'mx-0' : '']"
            color="primary background--text"
            dark
            @click.stop="onConfirm"
            >{{ $t("enrollment.steps.create_or_change_password.button")}}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
import ChangePassword from "@/components/consumer/ChangePassword"

export default {
    name:"EnrollmentChangePassword",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        }
    },
    data(){
        return{
            password:null,
            confirm_password:null
        }
    },
    components:{
        ChangePassword
    },
    watch:{
        password(){
            this.$emit("update:password", this.password);
        },
        confirm_password(){
            this.$emit("update:confirm_password", this.confirm_password);
        }
    },
    methods:{
        validate(){
            return this.$refs.changePasswordForm.validate();
        },
        onCancel(){
            this.$emit("onCancel");
        },
        onConfirm(){
            this.$emit("onConfirm");
        }
    }
}
</script>

<style>

</style>
